import { useMutation } from '@tanstack/react-query';

import { IDisputeEvidence } from '../common/contracts';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export default function useDisputes(disputeId?: string, publisherId?: string) {
  const axios = useAxios();

  const deleteDisputeEvidence = useMutation(async (evidenceId: string) => {
    return await axios.del(
      `${getApiRouteOrMock(EApiRoutes.DISPUTES)}/${disputeId}/${evidenceId}`,
      {},
      publisherId ? { 'x-publishers': publisherId } : undefined
    );
  });

  const updateDisputeEvidence = useMutation(
    async (evidence: Partial<IDisputeEvidence>) => {
      return await axios.put(
        `${getApiRouteOrMock(EApiRoutes.DISPUTES)}/${disputeId}/${evidence._id}?publisherId=${publisherId}`,
        evidence,
        publisherId ? { 'x-publishers': publisherId } : undefined
      );
    }
  );

  const addDisputeEvidence = useMutation(
    async (newDispute: Partial<IDisputeEvidence>) => {
      const formData = new FormData();
      for (const [key, value] of Object.entries(newDispute)) {
        if (value !== undefined) {
          formData.append(key, value as any);
        }
      }
      const url = `${getApiRouteOrMock(EApiRoutes.DISPUTES)}/${disputeId}?publisherId=${publisherId}`;
      const response = await axios.post(url, formData);
      return response.data;
    },
    {}
  );

  const getSignedUrlForEvidenceFile = useMutation(
    async ({
      filePath,
      evidenceId
    }: {
      filePath: string;
      evidenceId: string;
    }) => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.DISPUTES)}/${disputeId}/evidence/${evidenceId}/signed-url?filePath=${filePath}`
      );
    }
  );

  const submitEvidence = useMutation(async () => {
    return await axios.post(
      `${getApiRouteOrMock(EApiRoutes.DISPUTES)}/${disputeId}/submit`,
      {}
    );
  });

  return {
    deleteDisputeEvidence,
    updateDisputeEvidence,
    addDisputeEvidence,
    getSignedUrlForEvidenceFile,
    submitEvidence
  };
}
